export const ON_SET_ADVANCED_PARAMETER_REQUEST = 'ON_SET_ADVANCED_PARAMETER_REQUEST';
export const ON_SET_ADVANCED_PARAMETER_SUCCESS = 'ON_SET_ADVANCED_PARAMETER_SUCCESS';
export const ON_SET_ADVANCED_PARAMETER_FAILED = 'ON_SET_ADVANCED_PARAMETER_FAILED';
